// extracted by mini-css-extract-plugin
export default {"wrapper":"WithFixedSidebar_wrapper__OUiSS","sidebar":"WithFixedSidebar_sidebar__k4PKa","scrollable":"WithFixedSidebar_scrollable__YHewc","content":"WithFixedSidebar_content__CgmwX"};